import { HttpHandler, HttpHeaderResponse, HttpInterceptor, HttpProgressEvent, HttpRequest, HttpResponse, HttpSentEvent, HttpUserEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";

/*
 * Interceptor that handles calls to the back and answers
 */
@Injectable({
   providedIn: 'root'
 })
export class LoadingInterceptor implements HttpInterceptor {
   loadingCount: any = 0;

   constructor(private spinner: NgxSpinnerService) { }

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
      this.startLoading();

      return next.handle(request).pipe(
         finalize(() => this.stopLoading())
      )
   }

   startLoading() {
      this.loadingCount += 1;
      this.spinner.show();
   }

   stopLoading() {
      this.loadingCount -= 1;
      if (this.loadingCount === 0) {
         this.spinner.hide();
      }
   }
}
